<template>
    <div>
      <b-overlay :show="loading" spinner-type="grow">
        <Snapshot :is-snap-shot-sidebar-active.sync="isSnapShotSidebarActive" :user-data="userData" user-type="MEMBER" @clicked="one" />
    
        <SidebarCameraPreview :is-camera-sidebar-active.sync="isCameraSidebarActive" />
        <b-modal id="modal-xl" ref="modal-transfer" no-close-on-backdrop ok-title="Close" scrollable button-size="sm" size="md" title="Transfer Member">
            <b-form-group label="Transfer To" label-for="">
                <v-select v-model="transfer_to" :reduce="list => list.value" label="label" :options="transferListOptions" :clearable="false" input-id="client" />
            </b-form-group>
                  <b-alert show variant="danger" class="p-1 my-3 text-center">
                    注意：轉移後會員資料將會無檢視，請謹慎操作！<br>
                    Warning: After transfer, the member data will be inaccessible, please proceed with caution!
                  </b-alert>
                  
            <template #modal-footer="{ ok  }">
    
          <!-- Button with custom close trigger value -->
         <b-button size="sm" block variant="danger" @click="transfer()">
                      確定轉移 / Confirm Transfer
                    </b-button>
</template>
      </b-modal>


        <b-modal id="modal-xl" ref="modal-deposit-return" no-close-on-backdrop ok-title="Close" scrollable button-size="sm" size="md" title="Return Deposit">
            <b-form-group label="Return Payment Method 退還方式" label-for="">
                <v-select v-model="deposit_return_method" :reduce="list => list.value" label="label" :options="depositReturnListOptions" :clearable="false" input-id="client" />
            </b-form-group>
            <div v-if="deposit_return_method == 'last_month_fee'">
                            <b-row class="mt-2">
                                <b-col cols="6">
                                <v-select v-model="free_installment.year" :options="year" :clearable="false"/>
                                </b-col>
                                <b-col cols="6">
                                <v-select v-model="free_installment.month" :options="month" :clearable="false"/>
                                </b-col>
                            </b-row>
                        </div>
                   <b-alert show variant="danger" class="p-1 my-3 text-center">
                    注意：退還按金後將無法恢復按金狀態，請謹慎操作！<br>
                    Warning: After returning the deposit, the deposit status cannot be restored, please proceed with caution!
                  </b-alert>
                          
            <template #modal-footer="{ ok  }">
    
          <!-- Button with custom close trigger value -->
         <b-button size="sm" block variant="danger" @click="void_deposit()">
                      確定退還 / Confirm Return
                    </b-button>

        </template>
      </b-modal>



  <b-modal
      id="modal-xl"
      ref="modal-debit"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      
      button-size="sm"
      size="md"
      title="Debit Records"
    >
      <app-timeline>
    <app-timeline-item
      v-for="record in debit_records" :key="index" 
      :title=record.action_type
      :subtitle=record.amount
      :time="record.formatted_datetime"
      :variant="record.variant"
    />
  </app-timeline>
<template #modal-footer="{ ok , closeModal }">
    <!-- Button with custom close trigger value -->
    <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
    </b-button>
</template>
      </b-modal>



    <b-modal
      id="modal-xl"
      ref="modal-remarks"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      
      button-size="sm"
      size="md"
      title="Remarks"
    >
      <app-timeline>
    <app-timeline-item
      v-for="remark in full_remarks" :key="index" 
      :title=remark.display_name
      :subtitle=remark.remarks
      :icon="remark.icon"
      :time="remark.formatted_datetime"
      :variant="remark.type"
    />
  </app-timeline>
<template #modal-footer="{ ok , closeModal }">
    <!-- Button with custom close trigger value -->
    <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
    </b-button>
</template>
      </b-modal>
    <!-- Header: Personal Info -->
    <b-modal
      id="modal-xl"
      ref="my-modal"
      no-close-on-backdrop
      ok-title="Close"
      scrollable
      centered
      button-size="sm"
      size="lg"
      title="Snapshot"
    >
     <embed src="//www.cloudfit.pro/snapshot.php" width="100%" height="600px">
<template #modal-footer="{ ok , closeModal }">
    <!-- Button with custom close trigger value -->
    <b-button size="sm" variant="outline-secondary" @click="close()">
        Close
    </b-button>
</template>
      </b-modal>


    <b-row>
        <b-col md="7" lg="6">
          <div class="d-flex">
              <feather-icon icon="UserIcon" size="19"/>
              <h4 class="mb-0 ml-50">
                  {{ $t('Personal Information') }}
              </h4>
          </div>
            <!-- Form: Personal Info Form -->
            <b-form class="mt-1">
                <b-row>
                    <!-- Field: Mobile -->
                    <b-col cols="12" md="6" lg="8">
                        <b-form-group :label="$t('Member Code')" label-for="member_code">
                            <b-form-input id="member_code" v-model="userData.member_code"/>
                        </b-form-group>
                    </b-col>
                     <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Date Of Birth')" label-for="birth-date">
                            <flat-pickr v-model="birthDateValue" class="form-control" :config="{ dateFormat: 'Y-m-d'}" placeholder="YYYY-MM-DD"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Country Code')" label-for="country_code">
                            <v-select v-model="userData.country_code" :options="countryCodeOptions" :reduce="ans => ans.value"  :clearable="false" input-id="country_code"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Mobile')" label-for="mobile">
                            <b-form-input id="mobile" v-model="userData.mobile"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('Chinese Name')" label-for="zh_name">
                            <b-form-input id="zh_name" v-model="userData.zh_name"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('English Name')" label-for="en_name">
                            <b-form-input id="en_name" v-model="userData.en_name"/>
                        </b-form-group>
                    </b-col>

                   
                    <b-col cols="12" md="6" lg="6">
                        <b-form-group :label="$t('E-Mail')" label-for="email">
                            <b-form-input id="email" v-model="userData.email"/>
                        </b-form-group>
                    </b-col>
                    
                    <b-col cols="12" md="6" lg="6" v-if="permission_check(client_module.functions,37)">
                        <b-form-group :label="$t('Address')" label-for="address">
                            <b-form-input id="address" v-model="userData.address"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4" v-if="permission_check(client_module.functions,37)">
                        <b-form-group :label="$t('Identity Number')" label-for="identity_number">
                            <b-form-input id="identity_number" v-model="userData.identity_card"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Gender')" label-for="gender">
                            <v-select v-model="userData.gender" :options="genderOptions" :clearable="false" input-id="gender"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Created at')" label-for="created_at">
                            <b-form-input id="created_at" v-model="userData.created_at" disabled/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="8" v-if="permission_check(client_module.functions,42)">
                        <b-form-group :label="$t('Personal Trainer')" label-for="Personal Trainer">
                            <v-select v-model="userData.user_id" :reduce="ans => ans.value" :options="staffOptions" :clearable="true" multiple input-id="user_id"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Status')" label-for="status">
                            <v-select v-model="userData.status" :reduce="ans => ans.value" :options="statusOptions" :clearable="false" input-id="status"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="12">
                        <b-form-group :label="$t('Note')" label-for="note">
                            <b-form-textarea id="note" v-model="userData.remarks"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="12">
                        <b-form-group :label="$t('Check-in Remarks')" label-for="checkin-remarks">
                            <b-form-textarea id="checkin-remarks" v-model="userData.checkin_alert"/>
                        </b-form-group>
                    </b-col>
                    <!-- <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('Token')" label-for="created_at">
                            <b-form-input id="created_at" v-model="userData.token" disabled/>
                        </b-form-group>
                    </b-col> -->
                    <b-col cols="8" md="6" lg="8">
                        <b-form-group :label="$t('TAGS')" label-for="Tag">
                            <v-select 
                              v-model="userData.tags" 
                              label="label"
                              :options="tagOptions" 
                              :clearable="true" 
                              taggable
                              push-tags
                              multiple 
                              input-id="user_id"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4" md="6" lg="4">
                        <b-form-group :label="$t('Member Color')" label-for="member-color">
                            <v-select v-model="userData.color" :options="colorOptions" :reduce="val=>val.value" :clearable="false" input-id="member-color"/>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="12" lg="12">
                        <b-form-group :label="$t('Transfer Debit List')" label-for="Debit Transfer List">
                             <v-select
                                v-model="userData.transfer_debit_list"
                                @search="searchTimeOut"
                                :options="memberOptions"
                                :clearable="true"
                                multiple
                                :filterable="false"
                                placeholder="Please Enter Member Code..."
                                input-id="Client"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="mt-2 mb-2">
                    <b-col>
                        <b-button
                            variant="primary"
                            class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                            :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                            @click="save_member"
                            v-if="permission_check(client_module.functions,55)"
                            :disabled="disable_button"
                            >
                            {{$t("Save Changes")}}
                        </b-button>
                        <b-button v-if="permission_check(client_module.functions,55)" variant="outline-secondary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" :to="{ name: 'member-list' }">
                            {{$t("Cancel")}}
                        </b-button>
                    </b-col>
                </b-row>
            </b-form>
        </b-col>
        <b-col  md="4" lg="3">

          <img
            style="width:100%;border-radius:10px;"
            ref="previewEl"
            onerror="this.src='//cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png'" 
            :src="userData.avatar"
            size="100%"
            @click="update_to_device()"
            rounded
            class="mb-1"
          /><br>
          <b-alert
      v-height-fade.appear
      variant="danger"
      :show="userData.spam =='Y'"
      class="mb-0"
    >
      <div class="alert-body">
        <feather-icon
          icon="InfoIcon"
          class="mr-50"
        />
        已拒收whatsapp訊息
      </div>
    </b-alert>
    <b-alert show variant="warning" class="p-1  text-center" 
    v-if="userData.unreplied >= 5 "
      v-height-fade
      show
      dismissible
      fade>
                   已暫停 PT 訊息發送
    </b-alert>
          <b-button
            class="mt-1"
            block
            :disabled="disable_button"
            variant="primary"
            @click="snapshot2()"
            v-if="permission_check(client_module.functions,41)"
          >
          <feather-icon icon="CameraIcon" />
           <span> {{ $t('Start Camera') }} </span>
          </b-button>
          <!-- <b-button
            class="mt-1"
            block
            variant="success"
            @click="isCameraSidebarActive = true"
          >
            <feather-icon icon="VideoIcon" />
            <span> Camera Preview </span>
          </b-button> -->

          <b-button
            class="mt-1"
            block
            variant="outline-primary"
            @click="update_card()"
            :disabled="disable_button"
          >
          <feather-icon icon="RssIcon" />
          <span  v-if="userData.card_id"> {{ $t('Update Card') }} </span>
          <span  v-if="!userData.card_id"> {{ $t('Register Card') }} </span>
          </b-button>

          <b-button
            class="my-1"
            block
            size="sm"
            variant="outline-success"
            :disabled="disable_button"
            @click="update_to_device()"
            v-if="permission_check(client_module.functions,41)"
          >
          <feather-icon icon="RefreshCwIcon" />
           <span> {{ $t('Update Access Control') }} # {{ userData.member_id }} </span>
          </b-button>

            <b-button
            class="my-1"
            block
            size="sm"
            variant="outline-danger"
            :disabled="disable_button"
            @click="transfer_client()"
            v-if="userData.transfer == 'Y'"
          >
          <feather-icon icon="FastForwardIcon" />
           <span> 轉移 </span>
          </b-button>


          <div v-if="client_module.module.includes('debit')">
          <hr>
          <h4 class="mb-2"> <feather-icon icon="CreditCardIcon" size="19" /> {{ $t('Debit') }}</h4>
          <div class="text-center">
            <b-badge
              href="#"
              pill
              class="d-block"
              style="cursor:pointer;"
              variant="warning"
              @click="view_debit_records()"
            >
            <feather-icon icon="CreditCardIcon" size="19" /> $ {{ userData.debit }}
            </b-badge>
          </div>
          </div>
          <hr />
        <h4 class="mb-2"> <feather-icon icon="DollarSignIcon" size="19" /> {{ $t('Deposit') }}</h4>
            <b-list-group>
                <b-list-group-item v-for="deposit in userData.deposit" :key="index" class="d-flex justify-content-between align-items-center">
                    <span><b>{{deposit.code}}</b><br><span style="font-size:13px;color:#aaa;">{{deposit.created_at.substring(0,10)}}</span></span>
                    <b-badge variant="primary" pill class="badge-round">
                        {{deposit.amount}}
                    </b-badge>
                    <b-badge variant="danger" pill class="badge-round" style="cursor:pointer;" @click="void_deposit_model(deposit.uuid)">
                        <feather-icon icon="Trash2Icon" size="19"/>
                    </b-badge>
                </b-list-group-item>

            </b-list-group>
        </b-col>
        <b-col lg="3">
          <h4 class="mb-1">
                  {{ $t('Remarks') }} 
              </h4>
              <b-button-group size="sm" style="width:100%;">
                       <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
       @click="remarks_type = 'primary'"
      variant="outline-primary"
    >
      <feather-icon :icon="'Edit2Icon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-info"
       @click="remarks_type = 'info'"
    >
           <feather-icon :icon="'InfoIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-danger"
       @click="remarks_type = 'danger'"
    >
     <feather-icon :icon="'AlertTriangleIcon'" />
    </b-button>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-warning"
       @click="remarks_type = 'warning'"
    >
           <feather-icon :icon="'BellIcon'" />
    </b-button>

  </b-button-group>
    <b-form-textarea id="remarks" v-model="remarks_input" class="my-1"/>
    <b-button size="sm" block class="mb-1" @click="submit_remarks" :variant="remarks_type">{{$t("Submit")}}</b-button>
    <hr />
          <app-timeline>

    <app-timeline-item
      v-for="remark in remarks" :key="index" 
      :variant="remark.type"
      :icon="remark.icon"
    >

      <div class="d-flex align-items-start flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-50">
        
        <h6>{{remark.display_name}}</h6>
        <b-badge
          
          variant="light-primary"
        >
          {{remark.formatted_datetime }}
        </b-badge>
      </div>
      <div class="d-flex flex-sm-row flex-column justify-content-between align-items-start">
       <div v-html=" remark.remarks " />
        <div v-if="permission_check(client_module.functions,40)">
          <feather-icon icon="Trash2Icon" style="color:red;cursor: pointer;" @click="delete_remarks(remark.id)"/>
        </div>
      </div>
    </app-timeline-item>
  </app-timeline>
  <b-button @click="view_log()" class="mt-1" block size="sm" variant="outline-secondary">{{$t("View All")}}</b-button>
</b-col>
    </b-row>
    </b-overlay>
    <!-- <HorizontalTimeline :items="steps" /> -->
</div>
</template>



<script>
import {
    BFormTextarea,
    BCardText,
    BButtonGroup,
    BOverlay,
    BAlert,
    BLink,
    BCard,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormRadioGroup,
    BFormCheckboxGroup,
    BButton,
    BTab,
    BTabs,
    BListGroup,
    BListGroupItem,
    BBadge
} from 'bootstrap-vue'
import HorizontalTimeline from './HorizontalTimeline.vue'

import { ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import SidebarCameraPreview from './SidebarCameraPreview.vue'

import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Snapshot from './SidebarSnapshot.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import router from '@/router'
import EasyCamera from 'easy-vue-camera';
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'


export default {
    components: {
        ToastificationContent,
        BFormTextarea,
        'v-easy-camera': EasyCamera,
        AppTimeline,
        router,
        AppTimelineItem,
        BBadge,
        HorizontalTimeline,
        BButtonGroup,
        BButton,
        BCard,
        BOverlay,
        Snapshot,
        BCardText,
        vSelect,
        flatPickr,
        BAvatar,
        BListGroup,
        BListGroupItem,
        BForm,
        BFormGroup,
        SidebarCameraPreview,
        BMedia,
        BFormInput,
        BFormRadioGroup,
        BFormCheckboxGroup,
        BButton,
        BRow,
        BCol,
        BTab,
        BTabs,
        BCard,
        BAlert,
        BLink,
    },
    directives: {
        Ripple,
    },
    data() {
        return { steps: [
        { status: 'active', icon: 'fa-flag', label:{ line1:'建立', line2:'2025-01-01' }},
        { status: 'active', icon: 'fa-user-check', label:{ line1:'審批', line2:'2025-01-03' }},
        { status: 'deny',   icon: 'fa-ban', label:{ line1:'覆核', line2:'拒絕' }},
        { status: null,     icon: 'fa-hourglass', label:{ line1:'完成', line2:'待處理' }},
      ],
      year:[],
      month:['01','02','03','04','05','06','07','08','09','10','11','12'],
      free_installment:{
        year:null,
        month:null
      },
      colorOptions: [
        { label: 'Default 預設', value: 'primary' },
        { label: 'Grey 灰色', value: 'secondary' },
        { label: 'Blue 藍色', value: 'info' },
        { label: 'Yellow 黃色', value: 'warning' },
        { label: 'Green 綠色', value: 'success' },
        { label: 'Red 紅色', value: 'danger' }
        ],
            picture: null,
            remarks: [],
            timer: null,
            transferListOptions: [],
            loading: true,
            disable_button: false,
            memberOptions: [],
            transfer_to: null,
            full_remarks: [],
            deposit_return_method:null,
            depositReturnListOptions: [],
            selected_deposit:null,
            capturing: false,
            client_module: JSON.parse(localStorage.getItem('userData')),
            startOnMounted: false,
            centerOptions: [],
            debit_records: [],
            isSnapShotSidebarActive: false,
            staffOptions: [],
            isCameraSidebarActive: false,
            userData: {
                display_name: null,
                exsiting_username: null,
            },
            tagOptions: [],
            remarks_input: null,
            remarks_type: 'primary',
            countryCodeOptions: [
                {label: '🇭🇰 Hong Kong +852', value: '852'},
                { label: '🇨🇳 China +86', value: '86' },
                { label: '🇹🇼 Taiwan +886', value: '886' },
                { label: '🇲🇴 Macau +853', value: '853' },
                { label: '🇲🇾 Malaysia +60', value: '60' },
                { label: '🇸🇬 Singapore +65', value: '65' },
                { label: '🇬🇧 United Kingdom +44', value: '44' },
                { label: '🇦🇺 Australia +61', value: '61' },
                { label: '🇨🇦 🇺🇸 US / Canada +1', value: '1' },
                { label: '🇯🇵 Japan +81', value: '81' },
                { label: '🇰🇷 South Korea +82', value: '82' },
                { label: '🇹🇭 Thailand +66', value: '66' },
                { label: '🇵🇭 Philippines +63', value: '63' },
                { label: '🇮🇩 Indonesia +62', value: '62' },
                { label: '🇲🇳 Mongolia +976', value: '976' },
                { label: '🇻🇳 Vietnam +84', value: '84' },
                { label: '🇮🇳 India +91', value: '91' },
                { label: '🇧🇷 Brazil +55', value: '55' },
                { label: '🇲🇽 Mexico +52', value: '52' },
                { label: '🇷🇺 Russia +7', value: '7' },
                { label: '🇮🇹 Italy +39', value: '39' },
                { label: '🇪🇸 Spain +34', value: '34' },
                { label: '🇺🇿 Uzbekistan +998', value: '998' },
                { label: '🇰🇪 Kenya +254', value: '254' },
                { label: '🇫🇷 France +33', value: '33' },
                { label: '🇩🇪 Germany +49', value: '49' },
                { label: '🇳🇱 Netherlands +31', value: '31' },
                { label: '🇸🇪 Sweden +46', value: '46' },
                { label: '🇳🇴 Norway +47', value: '47' },
                { label: '🇩🇰 Denmark +45', value: '45' },
                { label: '🇫🇮 Finland +358', value: '358' },
                { label: '🇵🇱 Poland +48', value: '48' },
                { label: '🇧🇪 Belgium +32', value: '32' },
                { label: '🇨🇭 Switzerland +41', value: '41' },
                { label: '🇦🇹 Austria +43', value: '43' },
                { label: '🇮🇪 Ireland +353', value: '353' },
                { label: '🇵🇹 Portugal +351', value: '351' },
                { label: '🇬🇷 Greece +30', value: '30' },
                { label: '🇨🇿 Czech Republic +420', value: '420' },
                { label: '🇭🇺 Hungary +36', value: '36' },
            ],
            statusOptions: [
                { label: 'Active', value: 'ACTIVE' },
                { label: 'Disable', value: 'DISABLED' },
                { label: 'Deleted', value: 'DELETED' },
            ],
            genderOptions: [
                { label: 'Male', value: 'M' },
                { label: 'Female', value: 'F' },
            ],

        }
    },
    created() {
            const currentYear = new Date().getFullYear();
    for (let i = 0; i < 5; i++) {
      this.year.push(  currentYear + i);
    }
        this.get_member_data()
        this.get_center_data()
        this.get_staff_list()
        this.get_tag_data()
        this.get_member_remarks(5)
    },
    computed: {
        birthDateValue: {
            get() {
                if (!this.userData || !this.userData.birth || this.userData.birth === '0000-00-00') {
                    return ''
                }

                return this.userData.birth
            },
            set(value) {
                this.userData.birth = value || null
            },
        },
    },
    methods: {
        get_member_remarks(limit) {
            this.$http.get(process.env.VUE_APP_API_BASE + `/member/${router.currentRoute.params.id}/remarks/?limit=` + limit)
                .then(res => {
                  this.loading = false
                    this.full_remarks = res.data.remarks
                    if (res.data.remarks.length <= 5) {
                        this.remarks = res.data.remarks
                    }
                })
        },
        get_member_debit(limit) {
            this.$http.get(process.env.VUE_APP_API_BASE + `/member/${router.currentRoute.params.id}/debits/?limit=` + limit)
                .then(res => {
                    this.debit_records = res.data.records
                    if (res.data.remarks.length <= 5) {
                        this.debit_records = res.data.records
                    }
                })
        },
        view_log() {
            this.get_member_remarks(50)
            this.$refs['modal-remarks'].show()
        },

        searchTimeOut(search, loading) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        // your code
        this.currentPage = 1
        this.fetchOptions(search, loading)
      }, 1000)
    },
    fetchOptions (search, loading) {
      if (search === '') { return}
      setTimeout(() => { 
      this.$http.get(process.env.VUE_APP_API_BASE+'/search/member/?string='+search)
            .then(res => {
              if (res.data === false) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-center',
                  props: {
                    title: 'Error',
                    icon: 'XIcon',
                    variant: 'danger',
                    text: '符合資料太多, 請輸入更準確數據',
                  },
                })
              }
              this.memberOptions = res.data
            })
            }, 200);
      },


        view_debit_records() {
            this.get_member_debit(20)
            this.$refs['modal-debit'].show()
        },
        transfer_client() {
            this.$refs['modal-transfer'].show()
        },
        transfer() {
          this.$http.post(process.env.VUE_APP_API_BASE + `/member/${router.currentRoute.params.id}/transfer/`, { transfer_to: this.transfer_to})
                .then(res => {

                    if (res.data.result === true) {
                        this.$refs['modal-transfer'].hide()
                        this.$router.push({ name: 'member-list'})
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })

                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
        submit_remarks() {
            this.$http.post(process.env.VUE_APP_API_BASE + `/member/${this.userData.member_id}/remarks/`, { remarks: this.remarks_input, type: this.remarks_type })
                .then(res => {
                    if (res.data.result === true) {
                        this.remarks_input = null
                        this.remarks_type = 'primary'
                        this.get_member_remarks(5)
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
        delete_remarks(id) {
            this.$http.post(process.env.VUE_APP_API_BASE + `/member/${this.userData.member_id}/remarks/delete/`, { id: id })
                .then(res => {
                    if (res.data.result === true) {
                        this.get_member_remarks(5)
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
        one() {
            this.isSnapShotSidebarActive = false
            this.get_member_data()
        },
        update_card() {
            localStorage.setItem('reader_action', 'update_member_card')
            localStorage.setItem('member_id', this.userData.member_id)
            this.$swal({
                title: this.$t('Please Scan NFC Card'),
                icon: 'info',
                allowOutsideClick: false,
                confirmButtonText: this.$t('Cancel'),
                showDenyButton: true,
                denyButtonText: this.$t('Manual Input'),
                customClass: {
                    confirmButton: 'btn btn-primary',
                    denyButton: 'btn btn-outline-primary ml-1',
                },
                buttonsStyling: false,
            }).then(result => {
                if (result.value) {
                    localStorage.setItem('reader_action', 'normal')
                    localStorage.removeItem('member_id')
                } else if (result.isDenied) {
                    localStorage.setItem('reader_action', 'normal')
                    localStorage.removeItem('member_id')
                    this.update_card_manually()
                }
            })
        },
        update_card_manually() {
            this.$swal({
                title: this.$t('Manually Enter NFC Card Number'),
                input: 'text',
                inputPlaceholder: this.$t('Please Enter NFC Card Number'),
                showCancelButton: false,
                confirmButtonText: this.$t('Submit'),
                cancelButtonText: this.$t('Cancel'),
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-outline-secondary ml-1',
                },
                inputValidator: value => {
                    if (!value || !value.trim()) {
                        return this.$t('Please Enter NFC Card Number')
                    }
                    return null
                },
            }).then(result => {
                if (!result.value) {
                    return
                }

                this.$http.post(process.env.VUE_APP_API_BASE + `/member/${this.userData.member_id}/nfc/`, { card: result.value.trim() })
                    .then(res => {
                        if (res.data.result === true) {
                            this.get_member_data()
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-center',
                                props: {
                                    title: 'Success',
                                    icon: 'CheckIcon',
                                    variant: 'primary',
                                    text: res.data.message,
                                },
                            })
                        } else {
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-center',
                                props: {
                                    title: 'Error',
                                    icon: 'XIcon',
                                    variant: 'danger',
                                    text: res.data.message,
                                },
                            })
                        }
                    })
            })
        },
       
        go() {
            window.location = 'https://www.cloudfit.pro/snapshot.php?token=' + this.userData.token
        },
        snapshot2() {
            this.isSnapShotSidebarActive = true
        },
        start_cam() {
            this.capturing = true
            this.$refs.cam.start()
            this.$refs.cam.start()
        },
        close() {
            this.full_remarks = []
            this.$refs['modal-remarks'].hide()
            this.$refs['modal-transfer'].hide()

            this.$refs['modal-debit'].hide()
        },
        capture() {
            this.$refs.cam.snap()
        },
        old_capture() {
            this.$refs['my-modal'].show()
        },
        void_deposit_model(uuid) {
            this.selected_deposit = uuid
            this.$http.get(process.env.VUE_APP_API_BASE + '/payments/')
                .then(res => {
                    this.depositReturnListOptions = res.data
                    this.depositReturnListOptions.push({label:'Last Month Payment', value:'last_month_fee'})
                })
            this.$refs['modal-deposit-return'].show()
        },
        void_deposit() {
            
                    this.$http.post(process.env.VUE_APP_API_BASE + `/deposit/` + this.selected_deposit + `/return/?center_id=`+this.$store.getters['center/currentCenterId'], {
                            method: this.deposit_return_method,
                            free_installment: this.free_installment
                    })
                        .then(res => {
                            this.$refs['modal-deposit-return'].hide()
                            this.get_member_data()
                            this.$toast({
                                component: ToastificationContent,
                                position: 'top-center',
                                props: {
                                    title: 'Success',
                                    icon: 'CheckIcon',
                                    variant: 'success',
                                    text: 'Deposit voided',
                                },
                            })
                        })
        },
        get_staff_list() {
            this.$http.get(process.env.VUE_APP_API_BASE + '/staffs/select/?mode=all')
                .then(res => {
                    this.staffOptions = res.data
                })
        },

        update_to_device() {
            this.$http.post(`https://www.cloudfit.pro/access_control/api/v1/upload/${router.currentRoute.params.id}`)
                .then(res => {
                    if (res.data.result === true) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
        save_member() {
            this.$http.post(process.env.VUE_APP_API_BASE + `/member/${this.userData.member_id}/`, this.userData)
                .then(res => {
                    if (res.data.result === true) {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Success',
                                icon: 'CheckIcon',
                                variant: 'success',
                                text: res.data.message,
                            },
                        })
                    } else {
                        this.$toast({
                            component: ToastificationContent,
                            position: 'top-center',
                            props: {
                                title: 'Error',
                                icon: 'XIcon',
                                variant: 'danger',
                                text: res.data.message,
                            },
                        })
                    }
                })
        },
        snapshot() {
            this.$refs['my-modal'].show()
        },
        get_center_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + '/centers/')
                .then(res => {
                    this.centerOptions = res.data.centers
                })
        },
        get_tag_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + '/tags/select/')
                .then(res => {
                    this.tagOptions = res.data.tags
                })
        },
        get_member_data() {
            this.$http.get(process.env.VUE_APP_API_BASE + `/member/${router.currentRoute.params.id}/`)
                .then(res => {
                    this.userData = res.data
                    if (this.userData.transfer == 'Y') {
                      this.transferListOptions = res.data.transfer_list
                    }
                })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
